import React from 'react';

import { SectionContainer, ContentWidth } from '../../uiComponents';

import Arrow from './images/arrow.svg';
import { LinkBoxLabel, ArrowIcon, LinkBox } from './linkSection.styled';
import { LinkSectionData, LinkBoxData } from './linkSection.types';

export const LinkSection: React.FC<LinkSectionData> = (data: LinkSectionData) => {
  const { header, linkBoxes, className, boxesBaseUrl } = data;

  const getLinkBoxUrl = (url: string) => boxesBaseUrl
    ? `${boxesBaseUrl}/${url}`
    : url;

  const renderLinkBoxes = () => linkBoxes.map((linkBox: LinkBoxData) => (
    <LinkBox
      key={linkBox.post_name}
      href={getLinkBoxUrl(linkBox.post_name)}
    >
      <LinkBoxLabel>{linkBox.post_title}</LinkBoxLabel>
      <ArrowIcon src={Arrow} alt='arrow' />
    </LinkBox>
  ));

  return (
    <SectionContainer
      contentWithMode={ContentWidth.FullWidth}
      header={header}
      className={className}
      isGridModeEnable
    >
      {renderLinkBoxes()}
    </SectionContainer>
  );
}
